import { BrowserModule } from '@angular/platform-browser';

import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

import { HttpModule } from '@angular/http';
import { HttpClientModule,HttpClient,HttpParams } from '@angular/common/http';

import { RouterModule, Routes } from '@angular/router';
import { DefinitionComponent } from './definition/definition.component';

import { ShareButtonsModule, ShareButtonsOptions } from 'ngx-sharebuttons';

import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { AlphalistComponent } from './alphalist/alphalist.component';

import { AppComponent } from './app.component';
import { FeedCardComponent } from './feed-card/feed-card.component';
import { FeedService } from './feed.service';
import { StripHtmlTagsPipe } from './pipe/strip-html-tags.pipe';



const appRoutes: Routes = [
  { path: ':term', component: DefinitionComponent },
  { path: 'browse/:letter', component: AlphalistComponent }
];

const options: ShareButtonsOptions = {
  theme: 'material-dark',
  exclude: [ 'tumblr' ]
}

@NgModule({
  declarations: [
    AppComponent,
    DefinitionComponent,
    AlphalistComponent,
    FeedCardComponent,
    StripHtmlTagsPipe
  ],
  imports: [[
    RouterModule.forRoot(
        appRoutes,
        { enableTracing: true } // <-- debugging purposes only
      )
      // other imports here
    ],
    BrowserModule.withServerTransition({appId: 'my-app'}),
    NgbModule.forRoot(),
    FormsModule,
    HttpClientModule,
    HttpModule,
    ShareButtonsModule.forRoot(options),
    AngularFontAwesomeModule
  ],
  providers: [ FeedService ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/app/app.module.ts